import { combineReducers } from 'redux';
import * as t from './actionTypes';

const initialState = {
  authenticated: false,
  authError: null,
  loading: true,
  types: null,
  user: null,
};

const authenticated = (state = initialState.authenticated, action) => {
  switch (action.type) {
    case t.ADMIN_SIGNIN_SUCCESS:
      return true;
    case t.ADMIN_PROFILE_SUCCESS:
      return true;
    case t.ADMIN_SIGNOUT_USER:
      return false;
    case t.ADMIN_SIGNIN_FAILURE:
      return false;
    default:
      return state;
  }
};

const authError = (state = initialState.authError, action) => {
  switch (action.type) {
    case t.ADMIN_SIGNIN_FAILURE:
      return action.payload;
    case t.ADMIN_SIGNIN_SUCCESS:
      return null;
    case t.ADMIN_SIGNIN_REQUEST:
      return null;
    default:
      return state;
  }
};

const loading = (state = initialState.loading, action) => {
  switch (action.type) {
    case t.ADMIN_SIGNIN_REQUEST:
      return true;
    case t.ADMIN_SIGNIN_SUCCESS:
      return false;
    case t.ADMIN_SIGNIN_FAILURE:
      return false;
    case t.ADMIN_PROFILE_SUCCESS:
      return false;
    case t.ADMIN_PROFILE_FAILURE:
      return false;
    default:
      return state;
  }
};

const types = (state = initialState.types, action) => {
  switch (action.type) {
    case t.ADMIN_TYPES_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const user = (state = initialState.user, action) => {
  switch (action.type) {
    case t.ADMIN_PROFILE_SUCCESS:
      return action.payload;
    case t.ADMIN_SIGNOUT_USER:
    case t.ADMIN_SIGNIN_FAILURE:
    case t.ADMIN_PROFILE_FAILURE:
      return {};
    default:
      return state;
  }
};

export default combineReducers({
  authenticated,
  authError,
  loading,
  types,
  user,
});
